import { computed, InputSignal, Signal } from '@angular/core';
import { generateUniqueId } from './utilities';

/**
 * Creates a computed ID signal that uses provided ID or generates a unique one Standard pattern for all form controls
 * that need unique identifiers
 *
 * @example
 *   ```typescript
 *   export class HxInput {
 *     readonly id = input<string | undefined>(undefined);
 *     readonly computedId = createIdSignal(this.id, 'hx-input-');
 *     // If id='email', computedId returns 'email'
 *     // If id not set, computedId returns 'hx-input-a1b2c3d4'
 *   }
 *   ```;
 *
 * @param componentId - Input signal for explicit component ID
 * @param prefix - Prefix for generated IDs (e.g., 'hx-input-', 'hx-checkbox-')
 * @returns Computed signal that emits unique ID
 */
export function createIdSignal(componentId: InputSignal<string | undefined>, prefix: string): Signal<string> {
  return computed(() => {
    const providedId = componentId();
    if (providedId) {
      return providedId;
    }
    return generateUniqueId(prefix);
  });
}
